// extracted by mini-css-extract-plugin
export var tosLink = "_7m-0";